import React from "react";
import { Button } from "../";
import { RiCloseCircleFill } from "react-icons/ri";
import { InformationCircleIcon } from "@heroicons/react/solid";
import { toAbsoluteUrl } from "../../services";
function ComepetencyCard(props) {
  let { name, shortDescription, url, btnName } = props.item;
  return (
    <div className=" flex flex-col justify-center items-center">
      <div className="2xl:w-52 xl:w-52 lg:w-[98%] md:w-[80%] w-[90%] relative">
        <div
          className="h-52 bg-cover bg-no-repeat bg-top"
          style={{
            backgroundImage: `url(${toAbsoluteUrl(url)})`,
          }}
        >
          {props.name === name ? (
            <div className="bg-white shadow-md border-2 h-full">
              <div className="flex justify-end py-2 px-2 cursor-pointer">
                <RiCloseCircleFill
                  onClick={props.infoHide}
                  className="bg-[#007E8C] text-[#FEBB12] h-6 w-6 rounded-full "
                />
              </div>

              <div className="px-2">
                <p className="text-xs text-center ">{shortDescription}</p>
              </div>
            </div>
          ) : (
            <div>
              <div className="flex justify-end py-2 px-2 cursor-pointer">
                <InformationCircleIcon
                  onClick={props.infoClick}
                  className="bg-[#007E8C] text-[#FEBB12] h-6 w-6 rounded-full "
                />
              </div>

              <div className="bg-[#007E8C] absolute bottom-0 w-full py-2">
                <p className="text-white text-center">{name}</p>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="flex justify-center items-center my-2">
        <button
          disabled={props.disabled}
          onClick={props.onAddItem}
          className={`leading-normal capitalize rounded-lg shadow-md px-4 py-2.5 font-bold ${
            props.selected
              ? "bg-gray-300 hover:bg-gray-300"
              : "bg-[#FEBB12] hover:bg-[#FEBB12]"
          } text-[#3B4345]`}
        >
          {btnName}
        </button>
      </div>
    </div>
  );
}

export default ComepetencyCard;
